import React, { useState, useEffect } from "react";

import { motion } from "framer-motion";
import image2 from "@images/slider/2.jpg";
import slider1 from "@images/slider/offshore-oil-automated.webp";
import slider2 from "@images/slider/oil-gas-blog-hdr.jpg";
import slider3 from "@images/slider/super-subsea.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
// import image3 from "@images/slider/3.jpg";

const slides = [
  {
    id: 1,
    title: "Tecnologia Avançada para o Setor de Óleo & Gás",
    description:
      "Transforme sua eficiência operacional com nossas soluções inovadoras em válvulas, automação e segurança, sempre com foco na sustentabilidade e alto desempenho.",
    image: slider1,
    route: "/contact-us",
  },
  {
    id: 2,
    title: "Soluções Integradas em Automação Industrial",
    description:
      "Oferecemos tecnologias de ponta para otimizar processos e reduzir riscos, garantindo máxima segurança e confiabilidade para seus projetos.",
    image: slider2,
    route: "/contact-us",
  },
  {
    id: 3,
    title: "Excelência em Produtos e Serviços para o Mercado Offshore",
    description:
      "Com a Restart Design & Consulting, sua operação de Óleo & Gás se beneficia das melhores soluções em válvulas submarinas, gerenciamento de pipelines e automação de turbomáquinas.",
    image: slider3,
    route: "/contact-us",
  },
];

export const SliderSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Auto-cycle slides every 5 seconds
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [isPaused]);

  const handlePrevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slides.length) % slides.length,
    );
  };

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const navigate = useNavigate();
  const route = slides[currentSlide].route;
  const handleClick = () => {
    if (route) {
      window.scrollTo(0, 0);
      navigate(route);
    }
  };

  return (
    <div
      className="h-[60vh] w-full"
      style={{
        backgroundImage: `url(${slides[currentSlide].image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex h-full w-full flex-col items-center justify-end lg:justify-center">
        <div
          className="flex h-3/6 w-full flex-col items-center justify-between gap-4 rounded-sm bg-offwhite p-4 text-center shadow-lg lg:h-3/6 lg:w-4/6"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className={`flex h-full w-full flex-col items-center justify-evenly p-3`}
          >
            <h2 className="text-xl font-bold text-gray-800 lg:text-3xl">
              {slides[currentSlide].title}
            </h2>
            <p className="w-5/6 items-center justify-center text-xs text-gray-600 sm:w-2/3 sm:text-base">
              {slides[currentSlide].description}
            </p>
          </div>
          <div className={`flex w-full items-center justify-end p-1`}>
            <button
              onClick={handleClick}
              className="flex items-center gap-3 rounded-sm bg-primary-700 px-4 py-2 text-white transition-all hover:bg-primary-800 lg:px-5 lg:py-3"
            >
              Saiba mais
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </div>
      </div>

      {/* Left Arrow Button */}
      <button
        onClick={handlePrevSlide}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        className="absolute left-0 top-1/2 -translate-y-1/2 transform rounded-r-lg bg-gray-800 bg-opacity-50 p-3 text-white hover:bg-gray-900"
      >
        ◀
      </button>

      {/* Right Arrow Button */}
      <button
        onClick={handleNextSlide}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        className="absolute right-0 top-1/2 -translate-y-1/2 transform rounded-l-lg bg-gray-800 bg-opacity-50 p-3 text-white hover:bg-gray-900"
      >
        ▶
      </button>
    </div>
  );
};
